import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import consola from 'consola';
import OpenGraph from '~/components/functional/OpenGraph/EditorialOpenGraph.vue';
// import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import TcVars from '~/components/functional/TcVars/CustomizableHomePageTcVars.vue';
import { PRISMIC_URL } from '~/const/3rd';
import { components, typeDefinition, buildSlices } from '~/helpers/editorial-helper';
import { formatPrismicImage } from '~/helpers/image-helper';
import { fetchBlogCategories, fetchContent, fetchDocumentsById } from '~/services/editorial';
export default {
  name: 'Article',
  components: {
    Seo,
    OpenGraph,
    TcVars
    // RatingJsonLd,
  },

  validate(_ref) {
    var {
      params: {
        alias,
        slug
      }
    } = _ref;
    return alias && (slug || 'landing');
  },
  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=3600, public'
  }),
  asyncData(_ref2) {
    return _asyncToGenerator(function* () {
      var {
        error,
        params: {
          alias,
          slug = 'landing'
        },
        app: {
          apolloProvider
        },
        store
      } = _ref2;
      try {
        var _content$results;
        var definition = typeDefinition(alias);
        var content = yield fetchContent(store, {
          type: definition.type,
          slug,
          alias
        });
        if (!(content !== null && content !== void 0 && (_content$results = content.results) !== null && _content$results !== void 0 && _content$results.length)) {
          error({
            statusCode: 404,
            message: 'Not Found'
          });
          return false;
        }
        var {
          results: [{
            id,
            data,
            tags
          }]
        } = content;
        if (data.alias && data.alias !== alias) {
          error({
            statusCode: 404,
            message: 'Not Found'
          });
          return false;
        }
        var blogCategories = yield fetchBlogCategories(store);
        var slices = yield buildSlices(definition, data, apolloProvider.defaultClient, store);
        var {
          event_category: eventCategory,
          event_action: eventAction,
          event_label: eventLabel
        } = data;
        var tracking = {
          eventCategory,
          eventAction,
          eventLabel
        };
        var articleRecommendationSlice = data.body.filter(a => a.slice_type === 'article_recommendation');
        var articleRecommendationItems = articleRecommendationSlice.map(e => e.items);
        var ids = articleRecommendationItems.flat(1).map(e => e.article.id);
        var {
          results
        } = yield fetchDocumentsById(store, ids);
        return {
          results,
          blogCategories,
          type: definition.type,
          template: {
            path: definition.path,
            data,
            tracking
          },
          id,
          tags,
          slices
        };
      } catch (e) {
        error({
          statusCode: 404,
          message: 'Not Found'
        });
        return false;
      }
    })();
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    tcVars() {
      return this.template ? _objectSpread(_objectSpread({}, this.template.data), {}, {
        env_template: this.template.data.env_template || 'Landing Page'
      }) : {};
    },
    blogCategory() {
      var _this$blogCategories$;
      if (this.type !== 'article') return null;
      return (_this$blogCategories$ = this.blogCategories.find(item => item.data.category_label === this.tags[0])) === null || _this$blogCategories$ === void 0 ? void 0 : _this$blogCategories$.uid;
    }
  }),
  created() {
    if (this.template.path) {
      this[this.type] = () => components[this.type](this.template.path);
    }
    this.slices.forEach(_ref3 => {
      var {
        type,
        path
      } = _ref3;
      this[type] = () => components[type](path);
    });
  },
  beforeMount() {
    var prismicEdit = this.$cookies.get('editor');
    if (prismicEdit) {
      window.prismic = {
        endpoint: this.$store.state.sharedEnv.payload.prismic
      };
      this.asyncScript(PRISMIC_URL).then(() => {}).catch(err => {
        consola.error('PRISMIC FAILED', err);
        this.$logger.error("PRISMIC FAILED ".concat(err));
      });
    }
  },
  methods: {
    currentComponent(arg) {
      return this[arg];
    },
    options(_ref4) {
      var {
        global_background_color: backgroundColor,
        global_background_image: image
      } = _ref4;
      return process.browser ? _objectSpread(_objectSpread({}, backgroundColor && {
        style: {
          backgroundColor
        }
      }), image && image.url && {
        'data-bgset': formatPrismicImage(image.url),
        class: 'lazyload bg-center'
      }) : null;
    }
  }
};